ACC.productThumbnail = {
    _autoload: [
        'initComponent',
    ],

    initComponent() {
        const name = 'ProductThumbnail';
        const $component = $(`[data-component=${name}]`);

        if (!$component.length) {
            return;
        }

        this.start($component);
    },

    start($component) {
        $component.find('.thumbnail-box__view-large').on('click', function (e) {
            e.preventDefault();
            $modal.open(this);
        });
    },
};
